// @ts-check
import './plot-map-app-wrapper.css';
import { h } from 'preact';

import LoadingSpinner from '../LoadingSpinner';
import Message from '../Message';

const { __ } = wp.i18n;

/**
 * @param {object} props
 * @param {import('preact').ComponentChildren} props.children
 * @param {boolean} props.loading
 * @param {Error=} props.error
 * @param {boolean} props.noResults
 * @param {string} props.placeholderBackgroundImageSrc
 * @returns
 */
export default function PlotMapAppWrapper({
	children,
	loading = true,
	error = undefined,
	noResults = false,
	placeholderBackgroundImageSrc
}) {
	return (
		<div className={`plot-map-app-container ${error || noResults ? ' contains-message' : ''}`}>
			{loading && <div style={`background-image: url('${placeholderBackgroundImageSrc}');`} class="plot-map-placeholder-image" />}
			{loading && <LoadingSpinner />}
			{error && <Message type="error" message={error.message} />}
			{noResults && <Message message={__('No plot numbers found', 'real-estate-project')} />}
			{!loading && children}
		</div>
	);
}
